import SectionHeader from "@components/SectionHeader";
import ageGateIcon from "../img/age-gate-icon.svg";
const ContestAgeGate = () => {
  return (
    <div className="age-gate-contest">
      <SectionHeader>
        {" "}
        <strong>
          Erzähl deine persönliche <br />
          glo-Story und inspiriere
          <br /> andere
        </strong>{" "}
      </SectionHeader>
      <div className="age-gate-item">
        <img src={ageGateIcon} alt="age-gate" />
        <div className="content">
          <p className="desc big">
            Es tut uns leid, aber diese Aktivität ist ausschließlich{" "}
            <strong>für registrierte glo-Nutzer ab 25 Jahren</strong>{" "}
            vorgesehen, die glo seit mindestens 6 Monaten nutzen.
          </p>
          <p className="desc small">
            Freu dich auf weitere spannende Aktionen! <br />
            <strong>Bis zum nächsten Mal!</strong>
          </p>
        </div>
      </div>
    </div>
  );
};
export default ContestAgeGate;
